import { useObjectTypeSelect } from '../../hooks/useObjectTypeSelect';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorObjectTypeSelectSection = () => {
  const {
    defaultValue,
    filteringObjectDropdownLabel,
    hasOnlyOneOption,
    itemComponent,
    isCurrentObject,
    options,
    value,
    onChange
  } = useObjectTypeSelect(true);
  return /*#__PURE__*/_jsxs(View, {
    padding: "400",
    as: "div",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-200",
      marginBlockEnd: "300",
      children: filteringObjectDropdownLabel || /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataFiltersUI.objectTypeSelect.filteringOn.singlePanel",
        options: {
          type: isCurrentObject ? I18n.text('customerDataFiltersUI.objectTypeSelect.currentObject') : I18n.text('customerDataFiltersUI.objectTypeSelect.associatedObject')
        }
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      defaultValue: defaultValue,
      itemComponent: itemComponent,
      onChange: onChange,
      options: options,
      readOnly: hasOnlyOneOption,
      value: value
    })]
  });
};
export default EditorObjectTypeSelectSection;